import React, { useState } from "react";
import PDFLink from './PDFLink';
import Input from './Input';
import Questionmark from './Questionmark';
import Slider from './slider';
import { calculator, addSpaceSeparator, hasValue, getCompanyInformation }  from './util';
import './styles.css';

export default function App() {
  const [revenue, setRevenue] = useState(null)
  const [employee, setEmployee] = useState(null);
  const [companyType, setCompanyType] = useState("Tjänsteföretag");
  const [result, setResult] = useState("");
  const [warning, setWarning] = useState("");
  const [amountEmployee, setAmountEmployee] = useState(0);
  const [productivity, setProductivity] = useState(0);


  return (
    <>
      <div className="main-container">
      <h1 className="heading">Hur mycket kan hälsoarbetet förbättra ert resultat?</h1>
      <p> Denna kalkylator tar fram resultatförbättringen ni kan få, när ni använder Proformias hälsotjänster </p>
        <div className="form">
        <label className="form__organisation-select-label"> 
          <span className="form-label">Välj din typ av organisation:</span>

          <select
            value={companyType}
            onChange={event => setCompanyType(event.target.value)}
          >
            <option value={"Tjänsteföretag"}>Tjänsteföretag</option>
            <option value={"Serviceföretag"}>Serviceföretag</option>
            <option value={"Industriföretag"}>Industriföretag</option>
            <option value={"Handelsföretag"}>Handelsföretag</option>
            <option value={"Offentlig verksamhet"}>Offentlig verksamhet</option>
          </select>
        </label>

          <p><em className='form__company-explanation'> { getCompanyInformation(companyType) }</em></p>
       <label className="form__revenue-label">
       <span className="form-label">Ange er årliga omsättning/intäkt:</span>

      <Input value={revenue} onChange={setRevenue} />

      </label>
      <label className="form__employee-label">
      <span className="form-label">Ange antal anställda:</span>

        <Input value={employee} onChange={setEmployee} />

      </label>
      <Slider
         value={amountEmployee}
         onChange={setAmountEmployee}
         label="Uppskatta hur många procent av de anställda som kan förbättras:"
        questionmarkValue={<span>Tänk på att några av medarbetarna redan mår bra medan andra inte vill delta i programmet. <br /> Det är hos de övriga, ca 50% av medarbetarna, som den stora potentialen för förbättring finns.</span>}
      />

      <Slider 
        value={productivity}
        onChange={setProductivity}
        label=" Uppskatta hur stor förbättringen kan bli i genomsnitt:"
        questionmarkValue={<span>Ett exempel: på en 8-timmars arbetsdag innebär en förbättring med 5% att tiden som behövs för att <br /> klara en specificerad uppgift minskar med 24 minuter, vilket innebär 120 ”sparade” minuter per vecka.</span>}
        />

        <br/>
        <button
          className="form__button"
          onClick={event => {
          if (!hasValue(revenue) || !hasValue(employee) || !hasValue(amountEmployee)) {
            setResult(null);
            setWarning(<b>Alla fält måste fyllas i för att kunna beräkna ett resultat.</b>);
            return;
          }
          setWarning("");
            setResult(
              calculator(
                companyType,
                revenue,
                employee,
                (amountEmployee / 100),
                (productivity / 100)
              ))
            }
          }>
       Beräkna
        </button>
          { warning && <p className="form__warning-message">{warning}</p> }
        <br/>

        { hasValue(result) && !isNaN(result) &&
          <div className="form__result" style={{ display: 'flex' }}>
            <label> 
              <Questionmark value={<span>Till höger ser du hur ökad hälsa förbättrar resultatet genom högre produktivitet. Naturligtvis måste du ta <br /> hänsyn till kostnaden för programmet och tid som läggs ner för att det skall fungera.</span>}/>
              <b>Förbättrat resultat: </b> {addSpaceSeparator (Math.round(result))} kr


           </label> 

        <PDFLink 
          companyType={companyType}
          revenue={revenue}
          employee={employee}
          amountEmployee={amountEmployee}
          productivity={productivity} 
          result={Math.round(result)} />


         </div>


        }
      </div>
     </div>
     </>
     );
}
